
export interface ReactionRequest {
  reactionType: string;
}
